import * as React from 'react';
import { Tab, Nav, NavItem } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import ICalendar from '../calendar/ICalendar';
import ISelectEntity from '../../shared/interfaces/ISelectEntity';
import { AuthenticatedUser } from '../../shared/types';
import IWorkingAreaMap from '../workareas/IWorkingAreaMap';
import IPhotographerInput from './IPhotographerInput';
import PhotographerFormComponentInfo from './photographerForm/components/PhotographerFormComponentInfo';
import PhotographerFormComponentCompany from './photographerForm/components/PhotographerFormComponentCompany';
import PhotographerFormComponentExtraInfo from './photographerForm/components/PhotographerFormComponentExtraInfo';
import PhotographerFormComponentProducts from './photographerForm/components/PhotographerFormComponentProducts';
import PhotographerFormComponentCalendar from './photographerForm/components/PhotographerFormComponentCalendar';
import PhotographerFormComponentWorkArea from './photographerForm/components/PhotographerFormComponentWorkArea/PhotographerFormComponentWorkArea';
import PhotographerFormComponentPortfolio from './photographerForm/components/PhotographerFormComponentPortfolio';
import PhotographerFormComponentBlocked from './photographerForm/components/PhotographerFormComponentBlocked';
import { Firm } from './photographerForm/components/PhotographerFormComponentBlocked';

interface IAddPhotographerFormProps {
    calendar: ICalendar;
    user: IPhotographerInput;
    imageEditorFirms: ISelectEntity<number, string>[];
    blockedForFirms: Firm[];
    regions: ISelectEntity<number, string>[];
    agreements: ISelectEntity<number, string>[];
    updateCalendar: () => void;
    onChange: (e: any, targetName?: string) => void;
    onCreated: (event: any) => void;
    onUpdated: (event: any) => void;
    onDeleted: (event: any) => void;
    onCheckboxChange: (e: any) => void;
    onMapChange: (maps: IWorkingAreaMap[], userSite: number) => void;
    onPointChange: (point: any) => void;
    onCalendarChange: (calendar: ICalendar) => void;
    errors: any;
    products: {
        items: {
            id: number;
            name: string;
            site: { id: number; name: string };
        }[];
        selected: number[];
    };
    productAdded: (id: number) => void;
    productRemoved: (id: number) => void;
    isEditMode: boolean;
    shouldUpdateMap: boolean;
    availableLanguages: any[];
    onToggleShouldUpdateMap: (value: boolean) => void;
    onPropertyChange: (propery: string, value: any) => void;
    onRangeChanged: (from: any, to: any) => void;
    loggedInUser: AuthenticatedUser;
    createCubiCasaConnection: (userId: number) => any;
    site: string;
}

const PhotographerForm = (props: IAddPhotographerFormProps) => {
    function setTabValidationError(...properties: string[]) {
        if (!props.errors || Object.keys(props.errors).length === 0) {
            return null;
        }

        let hasErrors = properties.some((prop: string) => {
            return props.errors[prop] !== undefined;
        });

        return hasErrors ? (
            <i className="material-icons material-icons-danger material-icons-label md-18">error</i>
        ) : null;
    }

    return (
        <form>
            <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                <div>
                    <Nav>
                        <NavItem
                            eventKey={1}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/photographer')}
                            {setTabValidationError('name', 'username', 'email', 'phoneNumber')}
                        </NavItem>
                        <NavItem
                            eventKey={2}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/company')}
                            {setTabValidationError(
                                'address',
                                'company',
                                'organisationNumber',
                                'regionId',
                                'postalCode',
                                'city'
                            )}
                        </NavItem>
                        <NavItem
                            eventKey={3}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/info')}
                            {setTabValidationError(
                                'comment',
                                'agreementId',
                                'imageEditorFirmId',
                                'isDiscontinued',
                                'isBookableSe360',
                                'isBookableScandphotos',
                                'bGNr'
                            )}
                        </NavItem>
                        <NavItem
                            eventKey={4}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/photographer-products')}
                            {setTabValidationError()}
                        </NavItem>
                        <NavItem
                            eventKey={5}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(true);
                            }}
                        >
                            {Translate('photographers/modal/tab/workareas')}
                            {setTabValidationError()}
                        </NavItem>
                        <NavItem
                            eventKey={6}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/calendar')}
                            {setTabValidationError()}
                        </NavItem>
                        <NavItem
                            eventKey={7}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/portfolio')}
                            {setTabValidationError()}
                        </NavItem>
                        <NavItem
                            eventKey={8}
                            onClick={() => {
                                props.onToggleShouldUpdateMap(false);
                            }}
                        >
                            {Translate('photographers/modal/tab/blocked-for-firms')}
                            {setTabValidationError()}
                        </NavItem>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey={1}>
                            <PhotographerFormComponentInfo {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={2}>
                            <PhotographerFormComponentCompany {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={3}>
                            <PhotographerFormComponentExtraInfo {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={4}>
                            <PhotographerFormComponentProducts {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={5}>
                            <PhotographerFormComponentWorkArea {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={6}>
                            <PhotographerFormComponentCalendar {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={7}>
                            <PhotographerFormComponentPortfolio {...props} />
                        </Tab.Pane>
                        <Tab.Pane eventKey={8}>
                            <PhotographerFormComponentBlocked
                                blockedForFirms={props.blockedForFirms}
                            />
                        </Tab.Pane>
                    </Tab.Content>
                </div>
            </Tab.Container>
        </form>
    );
};

export default PhotographerForm;
